import { EditOutlined, WarningOutlined } from "@ant-design/icons";
import { List } from "antd";
import { useFormik } from "formik";
import { get, toString } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Filter from "../../../components/functional_components/Filter/Filter";
import { setFilters } from "../../../redux/ducks/Filters";
import { setLoading } from "../../../redux/ducks/Loading";
import Project from "../../../services/api/Project";
import { paginationDefaults } from "../../../utils/properties";
import { buildQueryString, showError } from "../../../utils/utilities";

const Projects = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const filters = useSelector((state) => state.FiltersDuck.filters);
  const [state, setState] = useState({
    tableContent: [],
    pagination: {
      currentPage: paginationDefaults.page,
      size: paginationDefaults.size,
      totalItems: paginationDefaults.totalItems,
    },
  });
  useEffect(() => {
    dataList(filters.string);
  }, []);
  const dataList = async (queryString) => {
    dispatch(setLoading(true));
    const projects = await Project.listProject(queryString);
    if (!projects.error && projects.data) {
      projects.data.forEach((cc, i) => {
        cc.key = i; // This is necessary to remove warning in console for unique key row
      });
      setState((prevState) => ({
        ...prevState,
        tableContent: get(projects, "data", []),
        pagination: {
          currentPage: projects.currentPage ? projects.currentPage + 1 : paginationDefaults.page,
          size: get(projects, "pageSize", paginationDefaults.size),
          totalItems: get(projects, "totalItems", paginationDefaults.totalItems),
        },
      }));
    } else {
      showError(get(projects, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };
  const formikFilter = useFormik({
    initialValues: {
      id: "",
      name: "",
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      // When I search, I start my page to 0
      values["page"] = 0;
      const queryString = buildQueryString(filters.obj, values);
      dispatch(setFilters(queryString));
      dataList(queryString.string);
    },
  });
  const resetFilter = () => {
    const queryString = buildQueryString(
      { page: toString(paginationDefaults.page - 1), size: toString(paginationDefaults.size) },
      {}
    );
    dispatch(setFilters(queryString));
    dataList(queryString.string);
  };
  const fieldsFilter = [
    {
      type: "input",
      isRequired: false,
      id: "id",
      name: "id",
      value: formikFilter.values.id,
      label: t("projects.filter.id"),
      onChange: formikFilter.handleChange,
      onBlur: formikFilter.handleBlur,
    },
    {
      type: "input",
      isRequired: false,
      id: "name",
      name: "name",
      value: formikFilter.values.name,
      label: t("projects.filter.name"),
      onChange: formikFilter.handleChange,
      onBlur: formikFilter.handleBlur,
    },
  ];
  return (
    <>
      <Filter formikForm={formikFilter} fields={fieldsFilter} onReset={resetFilter} />
      <List
        header={<strong>{t("menuLeft.projects")}</strong>}
        bordered
        size="small"
        pagination={{
          size: "small",
          showSizeChanger: false,
          current: state.pagination.currentPage,
          pageSize: state.pagination.size,
          total: state.pagination.totalItems,
          onChange: (page, pageSize) => {
            const queryString = buildQueryString(filters.obj, { page: toString(page - 1), size: pageSize });
            dispatch(setFilters(queryString));
            setState((prevState) => ({
              ...prevState,
              pagination: {
                currentPage: page,
                size: pageSize,
                totalItems: state.pagination.totalItems,
              },
            }));
            dataList(queryString.string);
          },
        }}
        dataSource={state.tableContent}
        renderItem={(item) => (
          <List.Item
            actions={[
              <div className="list-actions" key={item.id} onClick={() => navigate(`${item.id}`)}>
                <EditOutlined className="icon-medium" />
              </div>,
            ]}
          >
            <List.Item.Meta
              title={
                <div>
                  {item.userSupportPm === null ? <WarningOutlined key={item.id} className="PFred mr-10" /> : ""}{" "}
                  {`${item.id} | ${item.name}`}
                </div>
              }
            />
            <div>{item.status}</div>
          </List.Item>
        )}
      />
    </>
  );
};

export default Projects;
